import { Checkbox, Label } from "@tellescope/ui";
import { TemplateFormDialogContentsSectionForm } from "./types";
import { useTranslation } from "react-i18next";

export interface AdvancedSectionProps {
  form: TemplateFormDialogContentsSectionForm<"archivedAt" | "apiOnly">;
}

export const AdvancedSection = ({ form }: AdvancedSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <section className="space-y-6">
      <span className="flex gap-2">
        <Checkbox
          checked={form.values.archivedAt}
          onCheckedChange={(checked) => form.setFieldValue("archivedAt", !!checked)}
          id="archivedAt"
        />
        <Label className="flex flex-col gap-1 items-start" htmlFor="archivedAt">
          {t("Archived")}
          <p className="text-sm font-light text-muted-foreground">
            {t("Archive this template to hide from selection")}
          </p>
        </Label>
      </span>
      <span className="flex gap-2">
        <Checkbox
          checked={form.values.apiOnly}
          onCheckedChange={(checked) => form.setFieldValue("apiOnly", !!checked)}
          id="apiOnly"
        />
        <Label className="flex flex-col gap-1 items-start" htmlFor="apiOnly">
          {t("API Only")}
          <p className="text-sm font-light text-muted-foreground">
            {t("Hidden from template selectors in Tellescope UI")}
          </p>
        </Label>
      </span>
    </section>
  );
};
